import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { EditorData } from "../../state/AncillariesMapping/EditorData";

const updateAncillariesMappingEditorData: Reducer<EditorData> = (
  state: EditorData = new EditorData(),
  action: Action<ActionType, EditorData>
) => {
  switch (action.type) {
    case ActionType.ANCILLARIES_MAPPING_EDITOR_DATA_RESET:
      return new EditorData();
    case ActionType.ANCILLARIES_MAPPING_EDITOR_DATA_FETCHED:
      return { ...state, ancillariesMappingEditorData: action.data };
    case ActionType.ANCILLARIES_MAPPING_EDITOR_DATA_COPIED:
      return { ...state, ancillariesMappingEditorData: { ...action.data } };
    case ActionType.ANCILLARIES_MAPPING_EDITOR_DATA_UPDATED:
      return {
        ...state,
        ancillariesMappingEditorData: {
          ...state.ancillariesMappingEditorData,
          ...action.data,
        },
      };
    case ActionType.ANCILLARIES_MAPPING_EDITOR_DATA_SAVED:
      return { ...state, readyToSave: false };
    case ActionType.ANCILLARIES_MAPPING_EDITOR_DATA_VALIDATED:
      return { ...state, validation: { ...action.data } };
    case ActionType.ANCILLARIES_MAPPING_EDITOR_SET_BOUND_ITEM:
      return {
        ...state,
        ancillariesMappingEditorData: {
          ...state.ancillariesMappingEditorData,
          ...action.data,
        },
      };
    default:
      return state;
  }
};

export default updateAncillariesMappingEditorData;
